import { useEffect } from "react";

// Keeps the focused input visible above the on-screen keyboard on mobile
// browsers, without resizing the layout eliminating scroll jitter.
const useMobileAuthViewport = () => {
    useEffect(() => {
        const moveFocusedFieldIntoView = (event: FocusEvent) => {
            const target = event.target;
            if (!(target instanceof HTMLElement) || !target.closest(".mobile-auth-page")) return;

            window.setTimeout(() => {
                const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
                target.scrollIntoView({ behavior, block: "center" });
            }, 180);
        };

        document.addEventListener("focusin", moveFocusedFieldIntoView);
        return () => document.removeEventListener("focusin", moveFocusedFieldIntoView);
    }, []);
};

export default useMobileAuthViewport;